import '/app/brewery-packages/content/content-editor-plugin-unordered-list/src/UnorderedList.css-raw';
export default {
  "unorderedList": "news-4a753f38-unorderedList-wCRGkq"
};